// Components
import { FormField } from "@benchmark/ui/components/atomic";
import { FormGroup } from "@benchmark/ui/components/atomic";
import { FormSection } from "@benchmark/ui/components/atomic";
import { PractitionerRoleSearchSelect } from "@benchmark/ui/components/atomic";

// Types
import type { UseFormReturnType } from "@mantine/form";
import type { PatientFormData } from "@benchmark/core/types";

/**
 * Props for CareTeamSection component.
 * @agentic @benchmark/core
 */
type CareTeamSectionProps = {
  form: UseFormReturnType<PatientFormData>;
  benchmarkPractitionerRoleOptions: Array<{ value: string; label: string }>;
  loadingBenchmarkPractitioners: boolean;
  lcswSearchQuery?: string;
  onLcswSearchChange?: (query: string) => void;
  onLcswSelect?: (value: string | null) => void;
};

/**
 * Form section for Benchmark care team assignment (primary advocate).
 * @agentic @benchmark/core
 */
export const CareTeamSection = ({
  form,
  benchmarkPractitionerRoleOptions,
  loadingBenchmarkPractitioners,
  lcswSearchQuery = "",
  onLcswSearchChange,
  onLcswSelect,
}: CareTeamSectionProps) => {
  return (
    <FormSection title="Benchmark Care Team">
      <FormGroup>
        <FormField label="Primary Advocate" required>
          <PractitionerRoleSearchSelect
            options={benchmarkPractitionerRoleOptions}
            value={(form.values["benchmark-lcsw"] as string) || null}
            searchQuery={lcswSearchQuery}
            isSearching={loadingBenchmarkPractitioners}
            onSearchChange={onLcswSearchChange}
            onChange={
              onLcswSelect || form.getInputProps("benchmark-lcsw").onChange
            }
            placeholder="Search Benchmark staff..."
            noResultsMessage="No staff found"
            error={form.errors["benchmark-lcsw"]}
          />
        </FormField>
        {/* TEMPORARILY DISABLED: Assigned Advocate field no longer used in practice */}
        {/* <FormField label="Assigned Advocate">
          <Select
            placeholder="Select Advocate"
            data={benchmarkPractitionerRoleOptions}
            searchable
            clearable
            disabled={loadingBenchmarkPractitioners}
            {...form.getInputProps("benchmark-advocate")}
          />
        </FormField> */}
      </FormGroup>
    </FormSection>
  );
};
